/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-thumbs-up': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 6.875H12.5V3.75a2.275 2.275 0 00-2.5-2.5h-.981a.944.944 0 00-.894.731v.075L7.5 6.02 5.287 9.375H1.25v8.75h11.875c4.65 0 5.625-2.719 5.625-5v-3.75a2.275 2.275 0 00-2.5-2.5zM5 16.875H2.5v-6.25H5v6.25zm12.5-3.75c0 2.556-1.387 3.75-4.375 3.75H6.25v-6.688l2.5-3.706.456-3.356.088-.625H10c.9 0 1.25.35 1.25 1.25v4.375h5c.9 0 1.25.35 1.25 1.25v3.75z"/>'
  }
})
